<template>
  <div class="container py-4">
    <h2 class="mb-4 text-center">{{ groupName }}</h2>

    <div class="mb-3">
      <input type="text" class="form-control" v-model="searchQuery" placeholder="輸入商品名稱搜尋">
    </div>

    <div v-if="loading && products.length === 0">載入中...</div>
    <div v-else-if="filteredProducts.length === 0">找不到符合的商品</div>

    <div class="row">
      <div class="col-md-3 mb-4" v-for="product in visibleProducts" :key="product.id">
        <div class="card h-100" @click="goToProductDetail(product.id)" style="cursor: pointer;">
          <img :src="product.image ? domain + product.image : defaultImage" class="card-img-top" alt="商品圖片"
           style="padding: 20px; max-width: 100%; height: 200px; object-fit: contain; box-sizing: border-box;">
          <div class="card-body">
            <h5 class="card-title">{{ product.nameCH }} </h5>
            <p class="card-text">{{ product.nameEN }}</p> 
            <p class="card-text">尺寸：{{ product.dimension }}</p>
            <p class="card-text">售價：${{ product.suggestedRetailPrice }}</p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loading && products.length > 0" class="text-center my-3">載入更多中...</div>
  </div>
</template>

<script>
import api from '@/utils/api' // ✅ 改用共用 API 實例

export default {
  name: 'ProductListPage',
  data() {
    return {
      groupId: null,
      groupName: null, // 新增 groupName 屬性
      products: [],
      visibleCount: 20,
      loading: false,
      searchQuery: '',
      domain : process.env.VUE_APP_API_BASE,
      defaultImage: process.env.VUE_APP_API_BASE + "/amigurumi/pic/image-placeholder_640.png"
      //defaultImage: 'https://via.placeholder.com/300x180?text=No+Image'
    };
  },
  computed: {
    filteredProducts() {
      const keyword = this.searchQuery.trim().toLowerCase();
      if (!keyword) return this.products;
      return this.products.filter(p =>
        (p.nameCH && p.nameCH.toLowerCase().includes(keyword)) ||
        (p.nameEN && p.nameEN.toLowerCase().includes(keyword))
      );
    },
    visibleProducts() {
      return this.filteredProducts.slice(0, this.visibleCount);
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler(newId) {
        this.groupId = newId;
        this.fetchProducts();
      }
    },
    '$route.query.groupName': {
      immediate: true,
      handler(newGroupName) {
        this.groupName = newGroupName;
        console.log(this.groupName)
      }
    },
    searchQuery() {
      this.visibleCount = 20; // 重設懶加載
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    async fetchProducts() {
      this.loading = true;
      this.products = [];
      try {
        //const res = await fetch(`http://192.168.31.112:5001/api/Product?id=${this.groupId}`);
        const res = await api.get(`/api/Product/GetProductListByGroup?groupId=${this.groupId}`);
        console.log(res)
        this.products = await res.data;
        //const data = await res.json();
        //this.products = Array.isArray(data) ? data : [data];
      } catch (err) {
        console.error('取得商品失敗:', err);
      } finally {
        this.loading = false;
        this.visibleCount = 20;
      }
    },
    handleScroll() {
      const bottomReached = window.innerHeight + window.scrollY >= document.body.offsetHeight - 50;
      if (bottomReached && this.visibleCount < this.filteredProducts.length && !this.loading) {
        this.loading = true;
        setTimeout(() => {
          this.visibleCount += 20;
          this.loading = false;
        }, 300); // 模擬載入延遲
      }
    },
    goToProductDetail(productId) {
      this.$router.push({ name: 'ProductPage', params: { id: productId } });
    }
  }
};
</script>

<style scoped>
.card-img-top {
  object-fit: cover;
  height: 180px;
}
</style>
